import React from 'react';
import { LinkCategory } from '../../types/Links';
import LinkCard from '../LinkCard/LinkCard';
import './LinkCategorySection.css';

interface LinkCategorySectionProps {
  category: LinkCategory;
}

/// カテゴリ別リンクセクションコンポーネント - カテゴリごとにリンクをグループ表示
const LinkCategorySection: React.FC<LinkCategorySectionProps> = ({ category }) => {
  return (
    <section className="link-category-section" id={`category-${category.id}`}>
      <div className="category-header">
        <div className="category-title-wrapper">
          <span className="category-icon" role="img" aria-label={category.title}>
            {category.icon}
          </span>
          <h2 className="category-title">{category.title}</h2>
          <span className="category-count">({category.links.length})</span>
        </div>
        <p className="category-description">{category.description}</p>
      </div>

      <div className="category-links-grid">
        {category.links.map((link) => (
          <LinkCard
            key={link.id}
            link={link}
            categoryColor={category.color}
          />
        ))}
      </div>
    </section>
  );
};

export default LinkCategorySection; 